import { ServiceId } from "@mirage/discovery/id";
import * as service from "@mirage/discovery/services";

import type {
  PersonObject,
  PersonOrgChart,
  PersonTypeaheadSuggestion,
} from "@mirage/service-people/types";
import type { GetPeopleSuggestionsOptions, Service } from "./service";

const peopleService = service.getp<Service>(ServiceId.PEOPLE);

export default peopleService;

export function getPeopleSuggestions(
  options: GetPeopleSuggestionsOptions = {},
): Promise<PersonObject[]> {
  return peopleService.getPeopleSuggestions(options);
}

export function getPeopleTypeaheadSuggestions(): Promise<
  PersonTypeaheadSuggestion[]
> {
  return peopleService.getPeopleTypeaheadSuggestions();
}

export function getOrgChart(): Promise<PersonOrgChart[]> {
  return peopleService.getOrgChart();
}

export function performPeopleSearch(query: string): Promise<PersonObject[]> {
  return peopleService.performPeopleSearch(query);
}

export function tearDown(): Promise<void> {
  return peopleService.tearDown();
}
